import React, { useState, useEffect, useCallback } from 'react'
import anearApi from '../Api/AnearApi'
import UIStateContainer from '../Containers/UIStateContainer'
import EventList from '../UI/EventList'
import Box from '@mui/material/Box'
import {
  contentColumnMaxWidthSx,
  contentColumnPageShellSx
} from '../UI/contentColumn'

const NearbyPage = () => {
  const [events, setEvents]   = useState([])
  const [loading, setLoading] = useState(true)
  const [message, setMessage] = useState("No Events Found")

  const uiContainer = UIStateContainer.useContainer()
  const { startProgress, progressComplete } = uiContainer

  const fetchEvents = useCallback(async () => {
    const arr = await anearApi.playableEvents({ radius: 4000 }, true)
    setEvents(arr)
    return arr
  }, [])

  const reloadEvents = useCallback(async () => {
    try {
      startProgress()
      return await fetchEvents()
    } finally {
      progressComplete()
    }
  }, [fetchEvents, progressComplete, startProgress])

  useEffect(() => {
    let cancelled = false

    const loadEvents = async () => {
      try {
        startProgress()
        await fetchEvents()
      } catch (err) {
        console.error(err)
        if (err.message.includes("Geolocation")) {
          setMessage("Location Access Required")
        }
      } finally {
        if (!cancelled) setLoading(false)
        progressComplete()
      }
    }

    loadEvents()
    return () => { cancelled = true }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return null

  return (
    <Box sx={contentColumnPageShellSx}>
      <Box sx={{ ...contentColumnMaxWidthSx, overflowX: 'hidden' }}>
        <EventList
          playableEvents={events}
          message={message}
          onEventsChanged={reloadEvents}
        />
      </Box>
    </Box>
  )
}

export default NearbyPage
